import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Chevron Right icon for forward navigation
 */
export const ChevronRightIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polyline points="9 18 15 12 9 6"></polyline>
    </Icon>
  );
};

export default ChevronRightIcon;
